import React, { memo } from 'react';

import Chip from 'components/Chip';
import { IOption } from 'components/Select/Select';
import { DistinctiveBadgesContainer } from './styles';

interface IComponentProps {
  distinctiveLabels: IOption[];
}

const DistinctiveBadges: React.FC<IComponentProps> = ({
  distinctiveLabels,
}) => (
  <DistinctiveBadgesContainer>
    {distinctiveLabels
      .sort((a, b) => {
        return a.order - b.order;
      })
      .map((item) => {
        const { label, value } = item;
        return (
          <Chip
            key={`${value}_${label}`}
            chip={{ value, label }}
            selected={false}
          />
        );
      })}
  </DistinctiveBadgesContainer>
);
export default memo(DistinctiveBadges);
